import { mapState } from 'vuex'
import ProductServiceCategoryGroupEdit from '@/components/configs/productservicecategory/groupedit/ProductServiceCategoryGroupEdit.vue'
import ProductServiceCategoryEdit from '@/components/configs/productservicecategory/categoryedit/ProductServiceCategoryEdit.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

const defaultFilterValues = {
  isDeleted: [0]
};

export default {
  name: 'ProductServiceCategoryList',
  data () {
    return {
      isMounted: false,
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues)
    };
  },
  components: {
    ProductServiceCategoryGroupEdit,
    ProductServiceCategoryEdit,
    TableFilter
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = {
        categories: [
          { key: 'name', label: this.$t('product_service_category.category'), format: 'formatTranslation' },
          { key: 'group_id', label: this.$t('product_service_category.group'), format: 'formatFromConfig', configKey: 'product_service_category_groups', configParam: 'name' },
          { key: 'code', label: this.$t('general.item.code') },
          { key: 'order', label: this.$t('general.item.order') },
          { key: 'allowManufacture', label: this.$t('product_service_category.manufacture'), format: 'formatYesNo' },
          { key: 'allowImport', label: this.$t('product_service_category.import'), format: 'formatYesNo' }
        ],
        groups: [
          { key: 'name', label: this.$t('product_service_category.group'), format: 'formatTranslation' },
          { key: 'code', label: this.$t('general.item.code') },
          { key: 'order', label: this.$t('general.item.order') }
        ]
      }
      if (this.filterValues.isDeleted.includes(1)) {
        headers.categories.push({ key: 'deleted_at', label: this.$t('general.item.deleted'), format: 'formatYesNo' });
        headers.groups.push({ key: 'deleted_at', label: this.$t('general.item.deleted'), format: 'formatYesNo' });
      }
      if (this.canEdit) {
        let actions = [
          { label: this.$t('menu.config.product_service_category.category.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.config.product_service_category.category.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.config.product_service_category.category.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
        ];
        headers.categories.push({ key: 'actions', label: '', actions: actions });
        actions = [
          { label: this.$t('menu.config.product_service_category.group.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.config.product_service_category.group.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.config.product_service_category.group.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
        ];
        headers.groups.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    requestPath () {
      let path = 'product-service-categories/list';
      if (this.filterValues.isDeleted.length > 0) {
        path += '?isDeleted=' + this.filterValues.isDeleted.join(';');
      }
      return path;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    tableFilterConfig () {
      const filters = { };
      filters.isDeleted = { type: 'checkbox', label: this.$t('general.filters.deleted'), options: this.yesNoOptions };
      return filters;
    },
    tableActions () {
      const actions = { category: {}, group: {} };
      if (this.canEdit) {
        actions.category.add = { title: this.$t('menu.config.product_service_category.category.new') };
        actions.group.add = { title: this.$t('menu.config.product_service_category.group.new') };
      }
      return actions;
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.loading = false;
        }
      });
    },
    setDeleted (el, type, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('product-service-categories/deleted/' + type, this.ApiRequest.REQUEST_POST, { id: el.id, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el, type) {
      this.$refs[type + 'EditFrm'].show(el);
    },
    deleteItem (el, type, approved) {
      if (approved) {
        this.setDeleted(el, type, 1);
      } else {
        el.type = type;
        this.$refs.itemDeleteMsgBox.show(
          el,
          this.$t('menu.config.product_service_category.' + type + '.deleteTitle'),
          this.$t('menu.config.product_service_category.' + type + '.deleteMessage', { name: el.name[this.$i18n.locale] })
        )
      }
    },
    restoreItem (el, type) {
      this.setDeleted(el, type, 0);
    },
    itemsUpdated () {
      this.$store.dispatch('loadConfig');
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
